import { render } from "./default.vue?vue&type=template&id=483655ef&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import "./default.vue?vue&type=style&index=0&id=483655ef&lang=postcss&scoped=true"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483655ef"]])

export default __exports__